import React from "react"; // eslint-disable-line no-unused-vars
import Attachmentzone from "../../forms/Attachmentzone";
import "../../css/ui-elements/buttons.css";
import StaticConfig from "../StaticConfig";
import classNames from "classnames";
import {
  ABBVIE_EMPLOYEE,
  PATIENT,
  ENABLED_COUNTRIES,
  HCP,
} from "../../constants";
import { CircularProgress } from "@material-ui/core";
import { getCookie } from "../../helpers/CookieHandler";

class CertifyDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
    };
    this.reload = props.reload;
    this.handleReset = this.props.reset;
    this._completeUpload = this._completeUpload.bind(this);
    this._reset = this._reset.bind(this);
  }

  _completeUpload(files) {
    this.props._uploadedFiles(files);
  }

  componentWillReceiveProps({ reload }) {
    this.reload = reload;
  }

  _reset(event) {
    // this.props.reset; // unused expression
    this.child.getWrappedInstance()._reset();
  }

  render() {
    let cookieCountryLanguage = getCookie("welcomeLanguage");
    const { languageContent, field, flowType } = this.props;
    field.errors = field.errors || [];
    const hasErrors = field.errors.length > 0;
    const privacyPolicy = (
      <a
        data-tag="track-exit"
        data-analytics-text="Privacy Policy"
        href={languageContent.page.HOME.privacyPolicyLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
    );

    return (
      <div>
        {flowType === "MI_PORTAL_REQUEST" ? (
          <div>
            <div className="row">
              <div className="col-lg-12">
                <Attachmentzone
                  completeUpload={this._completeUpload}
                  ref={(cd) => (this.child = cd)}
                  lang={languageContent}
                  reload={this.reload}
                >
                  {languageContent.module.submitInquiry.uploadDocuments}
                </Attachmentzone>
              </div>
            </div>
            {this.props.field.display ? (
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className={
                      hasErrors ? "form-group has-danger" : "form-group"
                    }
                  >
                    <label
                      className={classNames(
                        "custom-control",
                        "custom-checkbox",
                        {
                          "consent-label": !hasErrors,
                        },
                      )}
                    >
                      <input
                        type="checkbox"
                        checked={this.props.field.value}
                        className="custom-control-input"
                        onChange={this.props.onConsentChange}
                      />

                      <span className="custom-control-indicator" />
                      <span
                        className="custom-control-description"
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {renderFirstElement(languageContent, StaticConfig)}

                        {StaticConfig.Context.UserType === ABBVIE_EMPLOYEE ? (
                          <b>
                            {" "}
                            {
                              languageContent.module.submitInquiry
                                .declarationAbbvieEmpBeforeLinkBold
                            }{" "}
                          </b>
                        ) : (
                          ""
                        )}
                        {StaticConfig.Context.UserType === HCP
                          ? languageContent.module.submitInquiry
                              .declarationHcpAfterLink
                          : ""}
                      </span>
                    </label>
                    {StaticConfig.Context.UserType === ABBVIE_EMPLOYEE ? (
                      <label
                        className={classNames(
                          "custom-control",
                          "custom-checkbox",
                          {
                            "consent-label": !hasErrors,
                          },
                        )}
                      >
                        <span
                          className="custom-control-description"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          <b>
                            {" "}
                            <u>
                              {
                                languageContent.module.submitInquiry
                                  .declarationForAbbvieEmployeePrivacyNoticeUS
                              }
                            </u>
                          </b>
                        </span>
                      </label>
                    ) : (
                      ""
                    )}
                    <label
                      className={classNames(
                        "custom-control",
                        "custom-checkbox",
                        {
                          "consent-label": !hasErrors,
                        },
                      )}
                    >
                      <span
                        className="custom-control-description"
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {StaticConfig.Context.UserType === HCP
                          ? languageContent.module.submitInquiry
                              .declarationAfterInitialDeclUS
                          : ""}
                        {StaticConfig.Context.UserType === ABBVIE_EMPLOYEE
                          ? languageContent.module.submitInquiry
                              .declarationForAbbvieEmployeeUS
                          : ""}
                        {cookieCountryLanguage !== "de" ? (
                          <span>
                            {
                              <a
                                data-tag="track-exit"
                                data-analytics-text="Your Privacy Choices"
                                href={
                                  languageContent.page.HOME
                                    .yourPrivacyChoiceLink
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Privacy Choices
                              </a>
                            }
                            {
                              languageContent.module.submitInquiry
                                .declarationAfterInitialDeclUS3
                            }
                            {
                              <a
                                data-tag="track-exit"
                                data-analytics-text="Privacy Policy"
                                href={
                                  languageContent.page.HOME.privacyNoticeLink
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Privacy Notice
                              </a>
                            }
                            {
                              languageContent.module.submitInquiry
                                .declarationAfterLink
                            }
                          </span>
                        ) : (
                          <span>
                            <a
                              data-tag="track-exit"
                              data-analytics-text="Privacy Policy"
                              href={
                                languageContent.page.HOME
                                  .deutschPrivacyPolicyLink
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Datenschutzerklärung
                              {languageContent.page.HOME.deutschPrivacyPolicy}.
                            </a>
                          </span>
                        )}
                      </span>
                    </label>

                    {StaticConfig.Context.UserType === ABBVIE_EMPLOYEE ? (
                      <label
                        className={classNames(
                          "custom-control",
                          "custom-checkbox",
                          {
                            "consent-label": !hasErrors,
                          },
                        )}
                      >
                        <span
                          className="custom-control-description"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          <b>
                            {" "}
                            <u>
                              {
                                languageContent.module.submitInquiry
                                  .declarationForAbbvieEmployeePrivacyNoticeNonUS
                              }
                            </u>
                          </b>
                        </span>
                      </label>
                    ) : (
                      ""
                    )}

                    {StaticConfig.Context.UserType === ABBVIE_EMPLOYEE ? (
                      <label
                        className={classNames(
                          "custom-control",
                          "custom-checkbox",
                          {
                            "consent-label": !hasErrors,
                          },
                        )}
                      >
                        <span
                          className="custom-control-description"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {
                            languageContent.module.submitInquiry
                              .declarationForAbbvieEmployeeNonUS
                          }

                          <a
                            data-tag="track-exit"
                            data-analytics-text="Privacy Policy"
                            href={languageContent.page.HOME.privacyPolicyLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {languageContent.page.HOME.privacyPolicyLink}
                          </a>
                        </span>
                      </label>
                    ) : (
                      ""
                    )}
                    {StaticConfig.Context.Country.name === "Australia" &&
                      StaticConfig.Context.UserType === HCP && (
                        <label
                          className={classNames(
                            "custom-control",
                            "custom-checkbox",
                            {
                              "consent-label": !hasErrors,
                            },
                          )}
                        >
                          <span
                            className="custom-control-description"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            Information displayed on this site is intended for
                            Australian Health Care Professionals only.
                          </span>
                        </label>
                      )}
                    {StaticConfig.Context.Country.name === "South Africa" &&
                      StaticConfig.Context.UserType === HCP && (
                        <label
                          className={classNames(
                            "custom-control",
                            "custom-checkbox",
                            {
                              "consent-label": !hasErrors,
                            },
                          )}
                        >
                          <span
                            className="custom-control-description"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            Information displayed on this site is intended for South Africa Health Care Professionals only.
                          </span>
                        </label>
                      )}  
                  </div>
                  {field.errors.map((error, i) => (
                    <div key={i} className="form-control-feedback">
                      {error}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="patient-privacy-disclosure">
                {StaticConfig.Context.UserType === PATIENT &&
                cookieCountryLanguage === "de" &&
                StaticConfig.Context.Country.name === "Germany" ? (
                  <a
                    data-tag="track-exit"
                    data-analytics-text="PrivacyNotice"
                    href={languageContent.page.HOME.privacyNoticeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Datenschutzerklärung
                  </a>
                ) : StaticConfig.Context.UserType === PATIENT &&
                  StaticConfig.Context.Country.name === "Germany" ? (
                  <a
                    data-tag="track-exit"
                    data-analytics-text="PrivacyNotice"
                    href={languageContent.page.HOME.privacyNoticeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {languageContent.page.HOME.germanPrivacyNotice}
                  </a>
                ) : (
                  <div>
                    {StaticConfig.Context.UserType !== ABBVIE_EMPLOYEE &&
                    StaticConfig.Context.Country.name === "United States"
                      ? languageContent.module.submitInquiry
                          .declarationAfterInitialDeclPPUS1
                      : languageContent.page.HOME.privacyChoiceLink
                        ? languageContent.module.submitInquiry
                            .declarationAfterInitialDeclPPUS2
                        : languageContent.page.HOME.privacyChoiceLink
                          ? languageContent.module.submitInquiry
                              .declarationAfterInitialDeclPPUS3
                          : languageContent.page.HOME.privacyChoiceLink
                            ? languageContent.module.submitInquiry
                                .declarationAfterInitialDeclPPUS4
                            : languageContent.page.HOME.privacyChoiceLink
                              ? languageContent.module.submitInquiry
                                  .declarationAfterInitialDeclPPUS5
                              : languageContent.page.HOME.privacyChoiceLink}

                    {
                      <a
                        data-tag="track-exit"
                        data-analytics-text="Your Privacy Choices"
                        href={languageContent.page.HOME.yourPrivacyChoiceLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Your Privacy Choices
                      </a>
                    }
                    {
                      languageContent.module.submitInquiry
                        .declarationAfterInitialDeclPPUS2
                    }
                    {
                      <a
                        data-tag="track-exit"
                        data-analytics-text="PrivacyNotice"
                        href={languageContent.page.HOME.privacyNoticeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Notice
                      </a>
                    }
                    {
                      languageContent.module.submitInquiry
                        .declarationAfterInitialDeclLink
                    }
                    <br />
                    {
                      languageContent.module.submitInquiry
                        .declarationAfterInitialDeclPPUS3
                    }
                    {
                      <a
                        data-tag="track-exit"
                        data-analytics-text="PrivacyNotice"
                        href={languageContent.page.HOME.howWeDiscloseYourData}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        "How We May Disclose Personal Data"
                      </a>
                    }
                    {
                      languageContent.module.submitInquiry
                        .declarationAfterInitialDeclPPUS4
                    }
                    {
                      <a
                        data-tag="track-exit"
                        data-analytics-text="Your Privacy Choices"
                        href={languageContent.page.HOME.yourPrivacyChoiceLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        "Your Privacy Choices "
                      </a>
                    }
                    {
                      languageContent.module.submitInquiry
                        .declarationAfterInitialDeclPPUS5
                    }

                    {
                      languageContent.module.submitInquiry
                        .declarationAfterInitialDeclLink
                    }
                    <br />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          ""
        )}
        {this.props.maintMsg && (
          <div className="row">
            <p className="employee-subtitle-warning-message">
              {languageContent.module.submitInquiry.submitDisableMessage}
            </p>
          </div>
        )}
        <div className="row">
          {flowType === "SCIBOOTH" ? (
            <div className="col-lg-12 scibooth-submit-panel">
              <button
                type="submit"
                onClick={() => this.props.setKioskSubmitType("SUBMIT_ONLY")}
                className="btn btn-info btn-lg submit-button btn-icon btn-rounded m-r-10 submit-gmis"
                disabled={this.props.loading}
              >
                {this.props.loading ? (
                  <div className="loading-text-centered">
                    <span>
                      {languageContent.module.submitInquiry.submitGmi}
                    </span>
                    <span className="loading-progress-centered">
                      <CircularProgress size={24} />
                    </span>
                  </div>
                ) : (
                  <React.Fragment>
                    {languageContent.module.submitInquiry.submitGmi}
                  </React.Fragment>
                )}
              </button>
              <button
                type="submit"
                onClick={() =>
                  this.props.setKioskSubmitType("SUBMIT_AND_EMAIL")
                }
                className="btn btn-info btn-lg-wide submit-button btn-icon btn-rounded m-r-10 send-docs"
                disabled={this.props.disableSend || this.props.loading}
              >
                {this.props.loading ? (
                  <div className="loading-text-centered">
                    <span>{languageContent.module.submitInquiry.send}</span>
                    <span className="loading-progress-centered">
                      <CircularProgress size={24} />
                    </span>
                  </div>
                ) : (
                  <React.Fragment>
                    {languageContent.module.submitInquiry.send}
                  </React.Fragment>
                )}
              </button>
              <button
                type="button"
                onClick={this.handleReset}
                className="btn btn-primary btn-outline hover btn-lg-wide btn-icon reset-button btn-rounded"
              >
                <span>{languageContent.module.submitInquiry.reset}</span>
              </button>
            </div>
          ) : (
            <div className="col-lg-8 submit-reset-panel">
              <button
                type="submit"
                className="btn btn-info btn-lg-wide submit-button btn-icon btn-rounded m-r-10"
                disabled={this.props.loading || this.props.maintMsg}
              >
                {this.props.loading ? (
                  <div className="loading-text-centered">
                    <span>{languageContent.module.submitInquiry.submit}</span>
                    <span className="loading-progress-centered">
                      <CircularProgress size={24} />
                    </span>
                  </div>
                ) : (
                  <React.Fragment>
                    {languageContent.module.submitInquiry.submit}
                  </React.Fragment>
                )}
              </button>
              <button
                type="button"
                onClick={this.handleReset}
                className="btn btn-primary btn-outline hover btn-lg-wide btn-icon reset-button btn-rounded"
              >
                <span>{languageContent.module.submitInquiry.reset}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function renderFirstElement(languageContent, StaticConfig) {
  if (StaticConfig.Context.UserType === HCP) {
    return languageContent.module.submitInquiry.declarationBeforeLink;
  } else if (StaticConfig.Context.UserType === ABBVIE_EMPLOYEE) {
    return languageContent.module.submitInquiry.declarationAbbvieEmpBeforeLink;
  } else {
    return languageContent.module.submitInquiry.declarationPatientBeforeLink;
  }
}

function renderEmployeeElement(languageContent, StaticConfig) {
  return "Employee content";
}
export default CertifyDocuments;



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/CertifyDocuments.js